var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 16.91 17.996",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.547 -3.0002)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.602 12.635c-0.5586-0.085-1.0547 0.2979-1.1348 0.8438-0.2012 1.3711-0.834 2.6221-1.8301 3.6182-2.5352 2.5352-6.6572 2.5332-9.1914 0-2.5337-2.5342-2.5337-6.6577 0-9.1914 0.9531-0.9526 2.1563-1.5737 3.5029-1.7998 0.5791-0.1099 1.2017-0.1289 1.8477-0.0557 0.887 0.1021 1.7126 0.3964 2.466 0.8285l-1.3019 0.2223c-0.5439 0.0933-0.9102 0.6099-0.8164 1.1543 0.083 0.4873 0.5059 0.8315 0.9844 0.8315 0.0557 0 0.1123-0.0044 0.1699-0.0142l3.4902-0.5967c0.2607-0.0449 0.4941-0.1914 0.6475-0.4082 0.1533-0.2163 0.2139-0.4849 0.1689-0.7466l-0.5977-3.4897c-0.0918-0.5439-0.6016-0.9082-1.1543-0.8169-0.5439 0.0933-0.9102 0.6104-0.8164 1.1548l0.1573 0.9185c-0.9679-0.543-2.0356-0.8943-3.17-1.0249-0.8496-0.0967-1.6738-0.0698-2.4282 0.0747-1.7368 0.291-3.3149 1.105-4.564 2.354-3.3135 3.3135-3.3135 8.7051 0 12.02 1.6567 1.6572 3.8335 2.4854 6.0098 2.4854 2.1768 0 4.3525-0.8281 6.0098-2.4854 1.3018-1.3018 2.1299-2.9414 2.3945-4.7412 0.0802-0.5469-0.2978-1.0548-0.8437-1.1348z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.66c84dfd.svg";
export { ForwardRef as ReactComponent };